import React from 'react';

/* eslint-disable react/prop-types */
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getFileIcon } from '../../utils/fileIcons';

const ListItem = styled('li')(({ theme }) => ({ margin: theme.spacing(0.5) }));
const FileListItem = ({
  name,
  onDelete,
}) => (
  <ListItem>
    <Chip
      label={name}
      icon={getFileIcon(name)}
      variant="outlined"
      sx={{ maxWidth: 200 }}
      onDelete={onDelete}
    />
  </ListItem>
);

export default FileListItem;
